document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__reviews-accordion details').forEach((reviews) => {
    const summary = reviews.querySelector('summary');
    reviews.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(reviews.open));
      summary.querySelector('[data-icon="plus"]').classList.toggle('hidden', reviews.open);
      summary.querySelector('[data-icon="minus"]').classList.toggle('hidden', !reviews.open);
    });
  });

  document.querySelectorAll('[data-product-reviews-link]').forEach((badge) => {
    badge.addEventListener('click', (event) => {
      const reviews = badge.closest('product-info')?.querySelector('.product__reviews-accordion details');
      if (!reviews) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reviews.open = true;
      const summary = reviews.querySelector('summary');
      summary.focus({ preventScroll: true });
      summary.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start'
      });
    }, true);
  });

  /**
   * Read more description toggle.
   */
  const button = document.querySelector('[js-description="read_more"]');

  button?.addEventListener('click', () => {
    button.classList.toggle('is-active');
    document.querySelector('[js-description="short"]').classList.toggle('hidden');
    document.querySelector('[js-description="full"]').classList.toggle('hidden');
    button.querySelector('[js-description="read_more_label"]').classList.toggle('hidden');
    button.querySelector('[js-description="read_less_label"]').classList.toggle('hidden');
  });

  /**
   * Gift sleeve option.
   */
  function updateProductGiftSleeve() {
    const wrapper = document.querySelector('[js-gift-sleeves="product-component"]');
    const productElement = wrapper.querySelector('[js-gift-sleeves="product"]');
    const containerElement = wrapper.querySelector('[js-gift-sleeves="container"]');
    const giftSleeveSpan = document.querySelector('[js-product-form="gift-sleeve"]');
    const variantElements = wrapper.querySelectorAll('[js-gift-sleeves="variant"]');
    const anyVariantActive = Array.from(variantElements).some((variant) => {
      const checkbox = variant.querySelector('[js-gift-sleeves-cart="checkbox"]');
      return checkbox && checkbox.checked;
    });

    if (!anyVariantActive) {
      containerElement?.removeAttribute('open');
      productElement?.setAttribute('aria-expanded', 'false');
      productElement?.classList.remove('hidden');
      productElement?.querySelector('[data-icon="minus"]').classList.add('hidden');
      productElement?.querySelector('[data-icon="plus"]').classList.remove('hidden');
    }

    productElement?.classList.toggle('hidden', anyVariantActive);
    giftSleeveSpan?.classList.toggle('hidden', !anyVariantActive);

    variantElements.forEach((element) => {
      const checkbox = element.querySelector('[js-gift-sleeves-cart="checkbox"]');
      const subtitle = element.querySelector('[js-gift-sleeves="price"]');

      if (checkbox) {
        checkbox.disabled = anyVariantActive && !checkbox.checked;
        element.classList.toggle('is-active', checkbox.checked);
        element.classList.toggle('hidden', anyVariantActive && !checkbox.checked);
        if (!anyVariantActive) element.classList.remove('hidden');

        if (subtitle) {
          subtitle.textContent = checkbox.checked
            ? `+ ${subtitle.textContent.replace(/^\+\s*/, '').trim()}`
            : subtitle.textContent.replace(/^\+\s*/, '').trim();
        }
      }
    });

    if (variantElements.length === 1 && !productElement) {
      const singleVariant = variantElements[0];
      const checkbox = singleVariant.querySelector('[js-gift-sleeves-cart="checkbox"]');

      if (checkbox) singleVariant.classList.toggle('is-active', checkbox.checked);
    }
  }

  document.querySelectorAll('[js-gift-sleeves-cart="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      updateProductGiftSleeve();
    });
  });
});
